<template>
  <q-dialog :visible="isVisible" :title="title" width="400px" :innerScroll="false" :showFooter="false" @close="onCancel">
    <el-form ref="form" :model="form" label-width="60px" size="small" v-loading="loading">
      <el-form-item label="店铺：">
        <el-select v-model="form.storeName" filterable style="width: 100%">
          <el-option v-for="item in useObjectList" :label="item.name" :key="item.code" :value="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类别：">
        <el-autocomplete
          style="width: 100%"
          v-model="form.category"
          :fetch-suggestions="querySkuList"
          @blur="getCategoryMappingBigModel(true)"
          @focus="onSkuCodeFocus(0)"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="型号：">
        <el-autocomplete
          style="width: 100%"
          v-model="form.bigModel"
          :fetch-suggestions="querySkuList"
          @blur="getCategoryMappingBigModel(true)"
          @focus="onSkuCodeFocus(2)"
        ></el-autocomplete>
      </el-form-item>
    </el-form>
    <div style="text-align: right; margin-top: 20px">
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary" :loading="loadingBtn" @click="onConfirm">确认</el-button>
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: 'StoreMainPushEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return this.isEdit ? '编辑' : '新增';
    },
    isEdit() {
      return !!this.row.dataId;
    },
  },
  data() {
    return {
      loading: false,
      loadingBtn: false,
      form: {},
      useObjectList: [],
      optionsn: [],
      inputData: [],
      inputIndex: 9,
    };
  },
  created() {
    this.initForm();
    this.salesGetStore();
    this.getOptionsn();
  },
  methods: {
    initForm() {
      if (this.isEdit) {
        this.form = {
          storeName: this.row.storeName,
          category: this.row.category,
          bigModel: this.row.bigModel,
        };
      } else {
        this.form = {};
      }
    },
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.loadingBtn = true;
      if (this.isEdit) {
        this.modify();
      } else {
        this.add();
      }
    },
    add() {
      this.$q.intelligentRecom
        .addMainModelConfig({ data: this.form })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success('新增成功');
            this.isVisible = false;
            this.$emit('success');
          }
        })
        .finally(() => {
          this.loadingBtn = false;
        });
    },
    modify() {
      let data = {
        dataId: this.row.dataId,
        ...this.form,
      };
      this.$q.intelligentRecom
        .modifyMainModelConfig({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success('编辑成功');
            this.isVisible = false;
            this.$emit('success');
          }
        })
        .finally(() => {
          this.loadingBtn = false;
        });
    },
    salesGetStore() {
      this.$q.intelligentRecom.getMainModelStore({}).then((res) => {
        this.useObjectList = res.data;
      });
    },
    onSkuCodeFocus(index) {
      this.inputIndex = index;
      if (index == 0) {
        this.inputData = this.optionsn.category;
      } else if (index == 1) {
        this.inputData = this.optionsn.style;
      } else {
        this.inputData = this.optionsn.bigModel;
      }
    },
    queryStringFales(queryString, cb) {
      let data = {
        categoryName: this.form.category,
        smallModel: this.form.smallModel,
        bigModel: this.form.bigModel,
      };
      this.$q.intelligentRecom
        .optionsn({ data: data })
        .then((res) => {
          this.optionsn = res.data;
          if (this.inputIndex == 0) {
            this.inputData = this.optionsn.category;
          } else if (this.inputIndex == 2) {
            this.inputData = this.optionsn.bigModel;
          }
          let data = this.inputData;
          if (!data || !data.allOptions) {
            cb([]);
            return;
          }
          let results = queryString
            ? data.allOptions.map((v) => v.criteriaContent).filter((item) => item.toLowerCase().includes(queryString.toLowerCase()))
            : data.allOptions
            ? data.allOptions.filter((v) => !v.useFlag).map((v) => v.criteriaContent)
            : [];
          if (!results || !results.length) {
            cb([]);
            return;
          }
          results = results.map((item) => ({
            ...item,
            value: item,
          }));
          cb(results);
        })
        .finally(() => {});
    },
    queryStringTrue(queryString, cb) {
      let data = this.inputData;
      if (!data || !data.allOptions) {
        cb([]);
        return;
      }
      let results = queryString
        ? data.allOptions.map((v) => v.criteriaContent).filter((item) => item.toLowerCase().includes(queryString.toLowerCase()))
        : data.allOptions
        ? data.allOptions.filter((v) => !v.useFlag).map((v) => v.criteriaContent)
        : [];
      if (!results || !results.length) {
        cb([]);
        return;
      }
      if (this.inputIndex == 0) {
        this.optionsn.bigModel = [];
        this.getCategoryMappingBigModel();
      } else if (this.inputIndex == 2 && queryString && queryString.length > 2) {
        this.optionsn.category = [];
        this.getCategoryMappingBigModel();
      }
      results = results.map((item) => ({
        ...item,
        value: item,
      }));
      cb(results);
    },
    querySkuList(queryString, cb) {
      if (queryString) {
        this.queryStringTrue(queryString, cb);
      } else {
        this.queryStringFales(queryString, cb);
      }
    },
    getOptionsn(data) {
      this.$q.intelligentRecom.optionsn({ data: data || {} }).then((res) => {
        this.$nextTick(() => {
          this.optionsn = res.data;
        });
      });
    },
    getCategoryMappingBigModel(type) {
      setTimeout(
        () => {
          let data = {
            categoryName: this.form.category,
            bigModel: this.form.bigModel,
          };
          this.getOptionsn(data);
        },
        type ? 200 : 0
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-select, >>> .el-autocomplete
  width 100% !important
</style>
